import hasSupportedPaymentMethods from "../web/components/landingPage/pages/Plans/utils/hasSupportedPaymentMethods";
import { useMemo } from "react";
import { sortBy } from "lodash/collection";

const useAvailablePaymentMethods = ({
  currentCurrencyOfferByPeriod,
  supportedPaymentMethods
}) => {
  const paymentMethods = currentCurrencyOfferByPeriod?.payment_methods ?? [];
  const hasSupportedPaymentMethod = hasSupportedPaymentMethods({
    paymentMethods,
    supportedPaymentMethods
  });

  return useMemo(() => {
    if (!hasSupportedPaymentMethod) {
      return [];
    }

    const methods = supportedPaymentMethods.filter(({ name }) => {
      const supportedPaymentMethod = paymentMethods.find(
        paymentMethodName => name === paymentMethodName
      );

      return typeof supportedPaymentMethod !== "undefined";
    });

    return sortBy(methods).reverse();
  }, [paymentMethods, supportedPaymentMethods]);
};

export default useAvailablePaymentMethods;
